<template>
  <v-dialog v-model="edit_modal" max-width="912" persistent content-class="elevation-0">
    <v-card :loading="loading" max-width="900" class="mb-5 mr-5">
      <v-card-title>{{(is_view_mode)?'User Details':'Edit User'}}</v-card-title>
      <v-card-text>
        <v-form :readonly="is_view_mode">
          <v-row dense class="mb-1">
            <v-col cols="2">
              <v-text-field
                label="First"
                dense
                autofocus
                v-model="form_data.first_name"
                :error-messages="form_error.first_name"
                :hide-details="!form_error.first_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="M.I"
                dense
                v-model="form_data.middle_name"
                :error-messages="form_error.middle_name"
                :hide-details="!form_error.middle_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Last"
                dense
                v-model="form_data.last_name"
                :error-messages="form_error.last_name"
                :hide-details="!form_error.last_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-autocomplete
                label="Role"
                :items="role_list"
                item-text="name"
                item-value="role_id"
                v-model="form_data.role_id"
                hide-details=""
                dense=""
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="d-flex justify-end long-space-user">
              <v-switch
                v-model="form_data.active"
                label="Active"
                color="success"
                hide-details
                class="mt-0"
                dense=""
                ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="2">
              <v-autocomplete
                dense
                label="Zip"
                v-model="form_data.zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :error-messages="form_error.zip"
                :hide-details="!form_error.zip"
                v-debounce:500="fetchZipCodes"
                :loading="zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense
                v-model="form_data.state_id"
                @change="getCity()"
                hide-details
              >
                <template
                  v-slot:selection="{ item }"
                >
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense
                v-model="form_data.city"
                @change="changeCity()"
                class="capitalize-first-letter"
                hide-details
              :search-input.sync="city_search"
              :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="city_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Mobile"
                dense
                v-model="form_data.mobile_number"
                :error-messages="form_error.mobile_number"
                :hide-details="!form_error.mobile_number"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-menu
                ref="h_date_menu"
                v-model="h_date_menu"
                :close-on-content-click="false"
                :return-value.sync="form_data.hire_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.hire_date"
                    label="Date of Joining"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.hire_date"
                    :hide-details="!form_error.hire_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  no-title
                  scrollable
                  @input="parseDate('hire_date')"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="h_date_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.h_date_menu.save(form_data.hire_date); changeStartDate()"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.address_line_1"
                :error-messages="form_error.address_line_1"
                :hide-details="!form_error.address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space">
            </v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Home"
                dense
                v-model="form_data.home_number"
                :error-messages="form_error.home_number"
                :hide-details="!form_error.home_number"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space">
            </v-col>
            <v-col cols="2" class="long-space-user">
              <v-menu
                ref="f_date_menu"
                v-model="f_date_menu"
                :close-on-content-click="false"
                :return-value.sync="form_data.fire_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.fire_date"
                    label="Date of Termination"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.fire_date"
                    :hide-details="!form_error.fire_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  no-title
                  scrollable
                  :min="disable_dates"
                  @input="parseDate('fire_date')"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="f_date_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.f_date_menu.save(form_data.fire_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense="" class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.address_line_2"
                :error-messages="form_error.address_line_2"
                :hide-details="!form_error.address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="SSN"
                v-mask="'###-##-####'"
                dense
                v-model="form_data.ssn_no"
                :error-messages="form_error.ssn_no"
                :hide-details="!form_error.ssn_no"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-select
                :items="timezone_list"
                label="Time Zone"
                dense
                v-model="form_data.time_zone"
                hide-details
                >
              </v-select>
            </v-col>
          </v-row>
          <v-row dense="">
            <v-col cols="3">
              <v-text-field
                label="Email"
                dense
                v-model="form_data.email"
                :error-messages="form_error.email"
                :hide-details="!form_error.email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="domain_list"
                label="Domain"
                dense=""
                v-model="form_data.email_domain"
                :error-messages="form_error.email_domain"
                :hide-details="!form_error.email_domain"
                prepend-icon="mdi-at"
              :search-input.sync="domain_search"
              :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Domain Found!</span> <span @click="addDomain" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user"></v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-menu
                ref="dob_menu"
                v-model="dob_menu"
                :close-on-content-click="false"
                :return-value.sync="form_data.date_of_birth"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.date_of_birth"
                    label="Birth Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.date_of_birth"
                    :hide-details="!form_error.date_of_birth"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  v-model="dateFormatted"
                  @input="parseDate('date_of_birth')"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dob_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dob_menu.save(form_data.date_of_birth)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense="" class="mb-1">
            <v-col cols="4">
              <v-text-field
                label="User ID"
                dense
                v-model="form_data.login_name"
                :error-messages="form_error.login_name"
                :hide-details="!form_error.login_name"
                disabled=""
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Password"
                dense
                :append-icon="show_pass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_pass ? 'text' : 'password'"
                v-model="form_data.password"
                :error-messages="form_error.password"
                :hide-details="!form_error.password"
                @click:append="show_pass = !show_pass"
              ></v-text-field>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Security Question-1"
                dense
                v-model="form_data.security_question_1"
                :error-messages="form_error.security_question_1"
                :hide-details="!form_error.security_question_1"
              ></v-text-field>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-autocomplete
              :items="job_types_list"
              label="Job Title"
              dense
              v-model="form_data.job_title"
              hide-details
              :search-input.sync="job_title_search"
              :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Job Title Found!</span> <span @click="addJobType" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense="" class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Allowed IP Address (comma separated)"
                dense
                v-model="form_data.new_allow_ip"
                :error-messages="form_error.new_allow_ip"
                :hide-details="!form_error.new_allow_ip"
              >
                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="22" v-bind="attrs" v-on="on" @click="allow_ip_dialog = true"> mdi-eye-outline </v-icon>
                    </template>
                    <span>View Allowed IP Address</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Security Question-2"
                dense
                v-model="form_data.security_question_2"
                :error-messages="form_error.security_question_2"
                :hide-details="!form_error.security_question_2"
              ></v-text-field>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-select
                :items="wage_type"
                label="Pay Structure"
                dense
                v-model="form_data.wage"
                hide-details
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense="" class="mb-1">
            <v-col cols="6">
              <v-select
                :items="days"
                label="Allowed Login Days"
                multiple
                dense
                v-model="form_data.working_days"
                :error-messages="form_error.working_days"
                :hide-details="!form_error.working_days"
              >
                <template v-slot:selection="{ index }">
                  <span class="grey--text caption" v-if="index == 0">
                    {{ form_data.working_days.length }} Selected
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Security Question-3"
                dense
                v-model="form_data.security_question_3"
                :error-messages="form_error.security_question_3"
                :hide-details="!form_error.security_question_3"
              ></v-text-field>
            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-text-field
                label="Pay Scale"
                dense
                v-model="form_data.pay_scale"
                :error-messages="form_error.pay_scale"
                :hide-details="!form_error.pay_scale"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense="" class="mb-1">
            <v-col cols="6">
              <div style="font-size: 16px;">
                Signature
              </div>
              <div v-if="signature_dialog" class="container update-sign">
                <VueSignaturePad
                  id="user_signature"
                  width="100%"
                  height="80px"
                  ref="userSignaturePad"
                  :options="{onBegin: () => {$refs.userSignaturePad.resizeCanvas()}}"
                />
              </div>
              <div v-if="signature_dialog" class="mt-2 text-center">
                <v-btn
                  outlined
                  small=""
                  @click="$refs.userSignaturePad.undoSignature()"
                >
                  Undo
                </v-btn>
                <v-btn
                  class="ml-2"
                  outlined
                  small=""
                  @click="$refs.userSignaturePad.clearSignature()"
                >
                  Clear
                </v-btn>
              </div>
              <div v-if="!signature_dialog" class="container display-sign d-flex justify-center align-center">
                <img v-if="form_data.user_sign" :src="form_data.display_user_sign" />
                <i v-else style="font-size: 20px;">{{form_data.display_user_sign}}</i>
              </div>
            </v-col>
            <v-col v-if="signature_dialog" class="less-space d-flex align-end" cols="1">
              <v-icon  @click="signature_dialog = false;">mdi-close</v-icon>
            </v-col>
            <v-col v-else  class="less-space d-flex" cols="1" style="flex-direction: column; justify-content: end;">
              <v-icon v-if="form_data.user_sign" @click="removeSign()">mdi-delete</v-icon>
              <v-icon @click="signature_dialog = true;">mdi-pencil</v-icon>
            </v-col>
            <v-col cols="2" class="long-space-user">

            </v-col>
            <v-col class="less-space" cols="1"></v-col>
            <v-col cols="2" class="long-space-user">
              <v-select
                :items="payroll_type"
                label="Pay Duration"
                dense
                v-model="form_data.payroll"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-0" v-if="is_view_mode">
        <v-btn
          fab
          color="error"
          x-small
          absolute
          @click="closePopup()"
          class="custom-close-btn"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!is_view_mode && (user_is_main_admin==1 || (user_is_main_admin==0 && user_id==id))" color="primary" @click="addUser()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="allow_ip_dialog" max-width="350" persistent>
      <v-card
        class="mx-auto align-self-stretch"
        tile
        :loading="ip_loading"
        width="100%"
      >
        <v-card-title class="headline pa-2">Allowed IP Address</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500;">
          <v-row dense v-if="form_data.allow_ip && form_data.allow_ip.length > 0" class="light-green lighten-4 primary--text">
            <v-col cols="12" class="pt-2" v-for="(ip, index) in form_data.allow_ip" :key="index">
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                @click="deleteIp(ip)"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
              <span class="ml-2">{{ ip.ip }}</span>
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">
              No Any Allowed IP Address!
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="allow_ip_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
  
</template>

<script>
import axios from "../../plugins/axios";
import { mapState,mapMutations } from "vuex";
export default {
  name: "UserEdit",
  data() {
    return {
      user_is_main_admin : localStorage.getItem('user_is_main_admin'),
      user_id:localStorage.getItem('user_id'),
      loading: false,
      dob_menu: false,
      h_date_menu: false,
      allow_ip_dialog: false,
      ip_loading: false,
      f_date_menu: false,
      show_pass: false,
      signature_dialog: false,
      city_search: null,
      form_data: {
        text_alert: false,
        email_alert: false,
        active: true,
        over_time_allowed: false,
        hours_allowed: false,
        date_of_birth: null,
        hire_date: null,
        fire_date: null,
        zip: "",
        docs_count: 0,
        ssn_no: "",
        mobile_number: "",
        home_number: "",
      },
      disable_dates: null,
      form_error: {},
      dateFormatted: null,
      job_title_search: null,
      zip_search: null,
      domain_search: null,
      zip_loading: false,
      timezone_list: [],
      zip_items: [],
      state_list: [],
      cities: [],
      domain_list: [],
      role_list: [],
      job_types_list: [],
      new_zip_id: null,
      fab_button: false,
      wage_type: [
        { value: "SALARY", text: "Salary" },
        { value: "SCOMMISSION", text: "Salary + Commision" },
        { value: "HOURLY", text: "Hourly" },
        { value: "CONTRACT", text: "Contract" },
        { value: "COMMISSION", text: "Commision" },
      ],
      payroll_type: [
        { value: "WEEK", text: "Weekly" },
        { value: "BIWEEK", text: "BI-Weekly" },
        { value: "MONTHLY", text: "Monthly" },
      ],
      days: [
        { text: "Sunday", short: "Sun", value: "0" },
        { text: "Monday", short: "Mon", value: "1" },
        { text: "Tuesday", short: "Tue", value: "2" },
        { text: "Wednesday", short: "Wed", value: "3" },
        { text: "Thrusday", short: "Thu", value: "4" },
        { text: "Friday", short: "Fri", value: "5" },
        { text: "Saturday", short: "Sat", value: "6" },
      ],
    };
  },
  watch: {
    edit_modal: {
      handler(val) {
        if (val) {
          this.signature_dialog = false
          this.getUser();
        }
      },
    },
    "form_data.zip": {
      handler() {
        this.getStates();
      },
    },
  },
  computed: {
    ...mapState("user", ["edit_modal","id","is_view_mode"]),
  },
  methods: {
    ...mapMutations("user", ["setData"]),
    removeSign() {
      this.loading = true;
      axios
        .post("remove_user_sign", {user_id: this.form_data.user_id})
        .then((response) => {
          if (response.data.status) {
            this.loading = false;
            this.form_data.user_sign = ''
            this.form_data.display_user_sign = response.data.user_data.display_user_sign
          }
        })
        .catch(function () {})
        .then(function () {
          this.loading = false;
        });
    },
    deleteIp(ip){
      this.ip_loading = true;
      let _self = this
      axios.post("delete_ip",ip).then(response => {
        if(response.data.status){
          _self.form_data.allow_ip = _self.form_data.allow_ip.filter(function(item){
            return item.user_ip_id != ip.user_ip_id
          })
        }
      }).catch(function(){
      }).then(function(){
        _self.ip_loading = false;
      })
    },
    closePopup() {
      this.setData({ key: "edit_modal", value: false });
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.state_id,city_name: _self.city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.cities.push({value: data.value,text: data.text});
          _self.form_data.city = data.value
          _self.changeCity()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    changeStartDate() {
      if(this.form_data.hire_date) {
        const [month, day, year] = this.form_data.hire_date.split("/");
        this.disable_dates = year+'-'+month+'-'+day
      } else {
        return this.disable_dates = null;
      }
    },
    addJobType() {
      this.loading = true;
      let _self = this;
      axios
      .post("add_job_types", {job_type: _self.job_title_search})
      .then(function (res) {
        let data = res.data.data;
        _self.job_types_list.push({value: data.job_id,text: data.job_type});
        _self.form_data.job_title = data.job_id
        _self.loading = false;
      })
      .catch(function (error) {
        console.log("FAILURE!!", error);
        _self.loading = false;
      });
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
      .post("add_domain", {domain: _self.domain_search})
      .then(function (res) {
        let data = res.data.data;
        _self.domain_list.push({value: data.domain_id,text: data.domain});
        _self.form_data.email_domain = data.domain_id
        _self.loading = false;
      })
      .catch(function (error) {
        console.log("FAILURE!!", error);
        _self.loading = false;
      });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", {zip_code: _self.zip_search})
        .then(function (res) {
          let data = res.data.data;
          _self.zip_items.push({value: data.value,text: data.text});
          _self.form_data.zip = data.value
          _self.new_zip_id = data.value
          _self.getStates();
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addUser() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      if(this.signature_dialog) {
        let userImageData = this.$refs.userSignaturePad.saveSignature('image/png');
        if(!userImageData.isEmpty) {
          serverData.user_sign_blob = userImageData.data
        } else {
          serverData.user_sign_blob = ''
        } 
      }
      axios
        .post("edit_user", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setData({ key: "edit_modal", value: false });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getCity() {
      let _self = this;
      axios
        .get("get_city?state_id=" + this.form_data.state_id)
        .then((response) => {
          if (response.data.status) {
            _self.cities = response.data.data;
          }
        })
        .catch(function () {});
    },
    changeCity() {
      if(this.form_data.zip == this.new_zip_id) {
        axios
          .post("zip_update",{state_id:this.form_data.state_id, zip_id:this.form_data.zip, city_id:this.form_data.city})
          .then(() => {

          })
          .catch(function () {});
      }

      this.zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.city)
      .then((response) => {
        if (response.data.status) {
          this.zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.zip_loading = false;
      });
    },
    getUser() {
      this.loading = true;
      let _self = this;
      axios.get("get_user?id=" + this.id).then(function (res) {
        if (res.data.status) {
          let data = res.data.data;
          for (let key in data) {
            
            // if(key == 'allow_ip') {
            //   let allow_ips = ''
            //   if(data[key]) {
            //     for(let i = 0; i < data[key].length; i++) {
            //       if(i == 0) {
            //         allow_ips = data[key][i]['ip']
            //       } else {
            //         allow_ips = allow_ips+','+data[key][i]['ip']
            //       }
            //     }
            //   }
            //   _self.form_data[key] = allow_ips;  
            // } else {
              _self.form_data[key] = data[key];  
            //}
          }
          if (data.state_id) {
            _self.getCity(false, data.city);
          }
          if (data.zip) {
            _self.zip_items.push({ text: data.zip, value: data.zip });
          }
        }
        _self.form_data.new_allow_ip = null
        _self.loading = false;
      });
    },
    getStates() {
      let _self = this;
      let zip = this.form_data.zip ? this.form_data.zip : "";
      axios
        .get("get_states?zip=" + zip)
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            if (response.data.selection) {
              this.cities = response.data.selection.all_city;
              this.form_data.state_id = response.data.selection.selected_state;
              this.form_data.city = response.data.selection.selected_city;
            }
          }
        })
        .catch(function () {});
    },
    getEmailDomains() {
      axios.get("get_domains").then((response) => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    getJobTypes() {
      let _self = this;
      axios
        .get("get_job_types")
        .then((response) => {
          if (response.data.status) {
            _self.job_types_list = response.data.data;
          }
        })
        .catch(function () {});
    },
    getTimezones() {
      axios
        .get("get_timezones")
        .then((response) => {
          if (response.data.status) {
            this.timezone_list = response.data.data;
          }
        })
        .catch(function () {});
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then((response) => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("k");
          this.zip_loading = false;
        });
    },
    parseDate(key) {
      console.log(key);
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    getRole() {
      this.loading = true;
      axios.get("role_list?&itemsPerPage=-1")
        .then((response) => {
          this.role_list = response.data.data.data;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });
    }
  },
  mounted: function () {
    this.getEmailDomains();
    this.getJobTypes();
    this.getStates();
    //this.getUser();
    this.getTimezones();
    this.getRole();
  },
};
</script>
<style scoped>
  .display-sign {
    padding: 8px 16px;
    border: solid 1px;
    height: 100px;
  }
  .update-sign {
    width: "100%";
    padding: 8px 16px;
    border: solid 1px;
  }
</style>